import {
  AppBar,
  Avatar,
  Grid,
  Link,
  makeStyles,
  MenuItem,
  Menu,
  MenuList,
  Select,
  TextField,
  Toolbar,
  IconButton,
  Card,
  CardContent,
  Typography,
  ListItem,
  List,
  ListItemIcon,
  ListItemText,
  Divider,
  InputLabel,
  Button,
  Popover,
  Box,
  Badge,
  createStyles,
} from "@material-ui/core";
import NotificationsNoneSharpIcon from "@material-ui/icons/NotificationsNoneSharp";
import NotificationDrawer from "../../../src/Pages/Roles/Admin/Notifications/NotificationDrawer";
import { fetchNotification } from "../../../src/Pages/Roles/Admin/Notifications/store/notificationService";
import React, { useState, useEffect } from "react";
import { ExpandMore, NotificationsNone } from "@material-ui/icons";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../Images/demo_client_new_logo.png";
import { queryClient } from "../..";
import { DELETE_DATA } from "../../Redux/actions";

const HeaderMenuComponent = (props: any) => {
  const { title } = props;

  const [menu, setMenu] = useState("");
  const [menuType, setMenuType] = useState("organization");
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [userData, setUserData] = useState();
  const history = useHistory();
  const dispatch = useDispatch();
  const globalUserData = useSelector((state: any) => state.commonReducer);
  let employeeId = globalUserData?.employee_id;
  let organisationId = globalUserData?.organisation_id;
  const preventDefault = (event: any) => event.preventDefault();

  const dynamicBackground =
    // globalUserData?.role === "admin"
    //   ? "linear-gradient(45deg, #470000 30%, #960000 90%)"
    //   :
    "linear-gradient(175deg, rgb(7 ,123 ,133) 30%, rgb(0,56,61) 90%)";
  // const dynamicBackground =
  //   sessionStorage.role === "admin"
  //     ? "linear-gradient(45deg, #470000 30%, #960000 90%)"
  //     : "linear-gradient(175deg, rgb(7 ,123 ,133) 30%, rgb(0,56,61) 90%)";

  const role = globalUserData?.role || "";
  const currentUserName = globalUserData?.userData?.name || "";
  let currentProfileLogo: string = globalUserData?.profile_logo as string;

  const navigationPermission = useSelector((state: any) => state.commonReducer)
    ?.accessPermission?.navigation;
  const showLeftNavBar = useSelector((state: any) => state.commonReducer)
    ?.accessPermission?.assignmentDetail.showLeftNavBar;

  const handleChange = (event: any) => {
    // setAuth(event.target.checked);
  };

  const handleMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const logout = () => {
    sessionStorage.clear();
    sessionStorage.removeItem("authorization_headers");
    sessionStorage.removeItem("jobRole");
    dispatch({ type: DELETE_DATA });
    //  return { type: LOG_OUT };

    queryClient.clear();
  };

  const renderUserOption = (e: any) => {
    return (
      <Link
        onClick={() => {
          history.push(e.listRoute);
          e.logout === "yes" && logout();
        }}
        aria-current="page"
      >
        <ListItem>
          <Typography variant="h2" style={{}}>
            {e.name}
          </Typography>
        </ListItem>
      </Link>
    );
  };

  const movePreviousPage = () => {
    history.goBack();
  };

  const [refreshNotification, setRefreshNotification] = useState(false);
  const notification = useSelector((state: any) => state.notifications);
  const [action, setAction] = useState<string>("");
  const handleCloseNotificationDrawer = (event: any, newValue: any) => {
    setAction("");
  };
  useEffect(() => {
    dispatch(fetchNotification());
  }, [refreshNotification]);
  return (
    <Grid direction="row" justify="center" alignItems="center">
      <Grid
        xs={12}
        justify="center"
        alignItems="center"
        style={{ background: dynamicBackground }}
      >
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          style={{ border: "0px solid red" }}
        >
          <Grid item xs={3}>
            {/* <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" >
                            <MenuIcon style={{ color: 'white', position: 'fixed', top: 20, bottom: 0, left: 30, right: 10, }} />
                        </IconButton> */}

            <img src={logo} alt="Acuity" className={classes.logoImg} />
            <div style={{ marginTop: "19px" }}>
              <div className={classes.designation}>
                {role === "finance_admin"
                  ? "Finance Admin"
                  : title ||
                    globalUserData.jobRole ||
                    globalUserData?.userData?.job_roles[0]}
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={role === "finance_admin" ? 5 : 6}
            alignItems="center"
            justify="center"
          >
            {
              <Toolbar style={{ float: "left" }}>
                {role === "employee" && (
                  <Typography variant="h2">
                    <Link
                      onClick={() => history.push("/OrganizationHome")}
                      className={classes.menuTitle}
                    >
                      Home
                    </Link>
                  </Typography>
                )}
                {/* {role === "finance_admin" && <div>
                  <Link onClick={() => history.push("/FinanceAdminHome")} className={classes.menuTitle}>
                    Home
                  </Link>
                </div>} */}

                {role === "employee" && (
                  <Typography variant="h2">
                    <Link
                      onClick={() => {
                        history.push("/ManageInfo");
                      }}
                      className={classes.menuTitle}
                    >
                      MI
                    </Link>
                  </Typography>
                )}

                {role === "employee" &&
                  navigationPermission?.includes("Dashboard") && (
                    <Typography variant="h2">
                      <Link
                        onClick={() => history.push("/dashboard")}
                        className={classes.menuTitle}
                      >
                        Dashboard
                      </Link>
                    </Typography>
                  )}

                {role === "employee" && (
                  <Typography variant="h2">
                    <Link
                      onClick={() => {
                        history.push("/admin/reports");
                      }}
                      className={classes.menuTitle}
                    >
                      Reports
                    </Link>
                  </Typography>
                )}

                {role === "employee" && (
                  <Typography variant="h2">
                    <Link
                      onClick={() => {
                        history.push("/admin/crf");
                      }}
                      className={classes.menuTitle}
                    >
                      Coaching request
                    </Link>
                  </Typography>
                )}

                {role === "employee" && (
                  <Typography variant="h2">
                    <Link
                      onClick={() => history.push("/CombineSearch")}
                      className={classes.menuTitle}
                    >
                      Coach search
                    </Link>
                  </Typography>
                )}
              </Toolbar>
            }
          </Grid>
          {/* { role === "finance_admin" &&  <Grid item xs={1} alignItems="center" justify="center">
              {role === "finance_admin" && <div>
                  <Link onClick={() => history.push("/FinanceAdminHome")} className={classes.menuTitle}>
                    Home
                  </Link>
                </div>}
                </Grid>} */}
          <Grid
            item
            xs={role === "finance_admin" ? 4 : 3}
            alignItems="center"
            justify="center"
          >
            <Toolbar style={{ float: "right" }}>
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                {role === "finance_admin" && (
                  <Link
                    onClick={() => history.push("/FinanceAdminHome")}
                    className={classes.menuTitle}
                  >
                    <Typography variant="h2" style={{ fontSize: "14px" }}>
                      Home
                    </Typography>
                  </Link>
                )}
                {role === "partner" && (
                  <Link
                    onClick={() => history.push("/CoachHome")}
                    className={classes.menuTitle}
                    style={{ marginRight: "10px" }}
                  >
                    <Typography
                      variant="h2"
                      style={{ fontSize: "14px", verticalAlign: "center" }}
                    >
                      Home
                    </Typography>
                  </Link>
                )}
                <Badge
                  badgeContent={notification?.notification?.unread_notifications_count?.toString()}
                  color="secondary"
                  onClick={() => {
                    setAction("notification");
                  }}
                >
                  <NotificationsNoneSharpIcon
                    className={classes.notifications}
                  />
                </Badge>
              </Box>
              <Box>
                <Box
                  onClick={(e) => {
                    handleMenu(e);
                  }}
                  display="flex"
                  alignItems="center"
                  style={{ cursor: "pointer" }}
                >
                  <Link className={classes.menuicon}>
                    <Typography variant="h2" style={{ fontSize: "14px" }}>
                      {currentUserName}
                    </Typography>
                  </Link>

                  <ExpandMore style={{ marginLeft: 10, color: "white" }} />
                </Box>

                {
                  <Popover
                    id={open ? "simple-popover" : undefined}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    style={{ zIndex: 9999, top: 12 }}
                  >
                    <List component="nav" aria-label="main mailbox folders">
                      {[
                        {
                          name: "My organization",
                          route: "/",
                          listRoute: showLeftNavBar
                            ? `/admin/organisation/${organisationId}`
                            : `/admin/organisation/${organisationId}/edit`,
                        },
                        {
                          name: "My profile",
                          route: "/",
                          listRoute:
                            role === "employee"
                              ? `/admin/organisation/${organisationId}/employee/${employeeId}/edit`
                              : "/partner/onboarding",
                        },
                        // {
                        //   name: "My profile",
                        //   route: "/",
                        //   listRoute: "/partner/onboarding",
                        // },
                        // { name: "Settings" },
                        {
                          name: "Sign out",
                          route: "/",
                          listRoute: "/",
                          logout: "yes",
                        },
                      ].map((e: any, index: any) =>
                        index == 0
                          ? role != "partner" && renderUserOption(e)
                          : renderUserOption(e)
                      )}
                    </List>
                    <Divider />
                  </Popover>
                }
              </Box>
              <Avatar
                style={{ marginTop: 2 }}
                alt={currentProfileLogo}
                src={currentProfileLogo}
              />
            </Toolbar>
          </Grid>
        </Grid>
      </Grid>
      {action && action == "notification" && (
        <NotificationDrawer
          action={action}
          handleClose={handleCloseNotificationDrawer}
          notificationList={notification?.notification}
          setRefreshNotification={setRefreshNotification}
        />
      )}
    </Grid>
  );
};

// const {
//     TextField,
//     InputAdornment,
//     IconButton,
//     SearchIcon,
//     Icon
//   } = window[''];

const useStyles = makeStyles((theme) => ({
  active: {
    borderLeft: "3px solid #3b86ff",
    backgroundColor: "#f4f4f4",
  },
  inActive: {
    borderLeft: "3px solid #fff",
  },
  logoImg: {
    width: "53px",
    // height:"40px",
    float: "left",
    marginLeft: 63,
    borderRadius: 5,
    backgroundColor: "linear-gradient(45deg, #009688 30%, #004d40 90%)",
  },
  menuicon: {
    color: "#fff",
    cursor: "pointer",
    fontSize: 14,
    marginLeft: 20,
  },
  menuOption: {
    border: "0px solid red",
    position: "absolute",
    zIndex: 1,
    // maxWidth: 360,
    // minWidth: 330,
    top: 52,
  },
  searchBar: {
    border: "2px solid red",
    color: "#fff",
  },
  orgSearchBox: {
    backgroundColor: "#565454",
    border: "0px solid red",
    height: 40,
    borderRadius: 5,
    color: "white",
  },
  searchBoxTitle: {
    color: "#fff",
    marginLeft: "10px",
    fontSize: "12px",
    "&:hover": {
      textDecoration: "none",
    },
  },
  searchBox: {
    borderLeft: "1px solid #707070",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: 1,
    marginLeft: 10,
  },
  inputBox: {
    backgroundColor: "transparent",
    borderWidth: "0px",
    color: "white",
    border: "1px solid red",
    height: "30px",
    width: "250px",
    marginLeft: 20,
  },
  searchIcon: {
    marginLeft: 20,
    color: "#fff",
    fontSize: 18,
  },

  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  title: {
    flexGrow: 2,
  },
  menuTitle: {
    marginRight: 40,
    color: "#fff",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "none",
    },
  },
  designation: {
    marginLeft: "8rem",
    color: "#fff",
    // cursor: "pointer",
    fontSize: 14,
    borderLeft: "1px solid #fff",
    paddingLeft: 20,
  },
  notifications: {
    marginLeft: 15,
    color: "#fff",
    cursor: "pointer",
    // fontSize: 18,
    width: "20px",
    height: "25px",
    "&:hover": {
      textDecoration: "none",
    },
    "& .MuiBadge-badge": {
      background: "rgb(239, 112, 0)",
    },
  },
}));

const homeHeaderMenuStyle = makeStyles((theme) =>
  createStyles({
    root: {
      position: "sticky",
      left: 0,
      right: 0,
      zIndex: 1301,
      top: 0,
    },
  })
);
function HomeHeaderMenu() {
  const classes = homeHeaderMenuStyle();
  return (
    <div className={classes.root}>
      <HeaderMenuComponent />
    </div>
  );
}

export default HomeHeaderMenu;
